/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Settings_Plc_MaintenanceInputs */



/**
* | output |
* | --- |
* | "PLC maintenance access" |
*
* @param {Module_Settings_Plc_MaintenanceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_plc_maintenance = /** @type {((inputs?: Module_Settings_Plc_MaintenanceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Plc_MaintenanceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("PLC maintenance access")
	return /** @type {LocalizedString} */ ("Accès maintenance automate")
});